<template>
    <a-modal
            :title="formType === 'charge'?'积分充值':'积分扣减'"
            :width="640"
            :visible="visible"
            :confirmLoading="confirmLoading"
            @ok="handleSubmit"
            @cancel="handleCancel"
    >
        <a-spin :spinning="confirmLoading">
            <a-form :form="form">
                <a-form-item
                        label="手机号"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    {{formData.phone}}
                </a-form-item>
                <a-form-item
                        label="昵称"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    {{formData.nickname}}
                </a-form-item>
                <a-form-item
                        label="积分"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    {{formData.point}}
                </a-form-item>
                <a-form-item v-if="formType === 'charge'"
                        label="充值积分"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    <a-input style="width: 70%" type="number" placeholder="输入充值的积分数量" v-decorator="['point', {rules: [{type: 'integer', required: true, min: 1, message: '充值的积分数量需为整数，且最小为1', transform: (value) => parseInt(value)}]}, ]" />
                </a-form-item>
                <a-form-item v-else
                             label="扣减积分"
                             :labelCol="labelCol"
                             :wrapperCol="wrapperCol"
                >
                    <a-input style="width: 70%" type="number" placeholder="输入扣减的积分数量" v-decorator="['point', {rules: [{type: 'integer', required: true, min: 1, max: formData.point,message: `扣减的积分数量需为整数，且最小为1，最多为` + formData.point, transform: (value) => parseInt(value)}]}, ]" />
                </a-form-item>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script>
    export default {
        data () {
            return {
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 7 }
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 13 }
                },
                visible: false,
                confirmLoading: false,

                form: this.$form.createForm(this),
                formData: {},
                formType: '',

                chargeValue: 0
            }
        },
        methods: {
            showForm(formData, formType) {
                this.form.resetFields()
                this.visible = true
                this.formData = formData
                this.formType = formType
            },

            handleSubmit () {
                const { form: { validateFields } } = this
                this.confirmLoading = true
                validateFields((errors, values) => {
                    if (!errors) {
                        setTimeout(() => {
                            this.visible = false
                            this.confirmLoading = false
                            values.phone = this.formData.phone
                            this.$emit(this.formType === "charge"?'charge':"consume", values)
                        }, 200)
                    } else {
                        this.confirmLoading = false
                    }
                })
            },
            handleCancel () {
                this.visible = false
            }
        },
    }
</script>
